const initializeClients = async () => Promise.all([])

export default initializeClients
